import { useContext, useMemo } from "react";

import {
  StyledEngineProvider,
  ThemeOptions,
  ThemeProvider,
  createTheme,
} from "@mui/material/styles";

import { CssBaseline } from "@mui/material";
import componentsOverride from "./overrides";
import Palette from "./palette";
import CustomShadows from "./shadows";
import Typography from "./typography";
import { AppContext } from "contexts/AppContext";

export default function ThemeCustomization({
  children,
}: {
  children: JSX.Element;
}) {
  const appValue = useContext(AppContext);
  const theme = Palette(appValue.mode);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const themeTypography = Typography(`'Public Sans', sans-serif`);
  const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme]);

  const themeOptions = useMemo(
    () => ({
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1536,
        },
      },
      direction: "ltr",
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
      palette: theme.palette,
      customShadows: themeCustomShadows,
      typography: themeTypography,
    }),
    [theme, themeTypography, themeCustomShadows]
  );

  const themes = createTheme(themeOptions as ThemeOptions);
  themes.components = componentsOverride(themes);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
